export const FETCH_UNIT_WITH_DEVIATION_WITHOUT_MIN_MAX_REQUEST = 'FETCH_UNIT_WITH_DEVIATION_WITHOUT_MIN_MAX_REQUEST'
export const FETCH_UNIT_WITH_DEVIATION_WITHOUT_MIN_MAX_SUCCESS = 'FETCH_UNIT_WITH_DEVIATION_WITHOUT_MIN_MAX_SUCCESS'
export const FETCH_UNIT_WITH_DEVIATION_WITHOUT_MIN_MAX_FALUIRE = 'FETCH_UNIT_WITH_DEVIATION_WITHOUT_MIN_MAX_FALUIRE'
